var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUae(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 7.27998V16.28H70.25V7.27998C70.25 3.61281 67.2772 0.639984 63.61 0.639984H6.89C3.22283 0.639984 0.25 3.61281 0.25 7.27998Z",
    fill: "#00732F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 32H70.25V16.31H0.25V32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 41C0.25 44.6672 3.22283 47.64 6.89 47.64H63.61C67.2772 47.64 70.25 44.6672 70.25 41V32H0.25V41Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61 0.629995C3.09747 0.629995 0.25 3.47746 0.25 6.99V41.26C0.25 44.7725 3.09747 47.62 6.61 47.62H18.25V0.619995L6.61 0.629995Z",
    fill: "#FF0000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUae);
export default __webpack_public_path__ + "static/media/UAE.fc64fc262a414a9b47c61ae173c06734.svg";
export { ForwardRef as ReactComponent };